export enum REPORT_TYPE {
  RETAIL = 'Retail',
  NORMAL = 'Normal',
}
